// extracted by mini-css-extract-plugin
export default {"box":"ChartsBlock_box__NgjDh","donuts":"ChartsBlock_donuts__8g75B"};